import {Button} from "@progress/kendo-react-buttons"
import {filterBy} from "@progress/kendo-data-query"
import {DateRangePicker, DateRangePickerChangeEvent, SelectionRange} from "@progress/kendo-react-dateinputs"
import {
    ListItemProps,
    MultiSelect,
    MultiSelectChangeEvent,
    MultiSelectFilterChangeEvent,
} from "@progress/kendo-react-dropdowns"
import {Field, FieldRenderProps, Form} from "@progress/kendo-react-form"
import {Checkbox, Input, InputChangeEvent} from "@progress/kendo-react-inputs"
import {MDBCol, MDBRow} from "mdbreact"
import React, {createRef, useCallback, useEffect, useState} from "react"
import {RootState} from "../../../rootReducer"
import {useAppSelector} from "../../../store"
import {FeesReportParams} from "../../../containers/MotBooking/bookingSlice"

const FeesReportFilter = ({getFeeReports}: {getFeeReports: (data: FeesReportParams) => void}) => {
    const userDealers = useAppSelector((state: RootState) => state.application.userDealers)
    const feesReportFilter = useAppSelector((state: RootState) => state.containers.motBooking.feeReportFilters)
    const [dateValidation, setDateValidation] = useState(true)
    const [dealerData, setDealersData] = useState(userDealers)
    const [dateRangeValue, setDateRange] = useState<SelectionRange>(feesReportFilter.dateRange)
    const searchRef = createRef<any>()

    const [filterParam, setFilterParams] = useState<FeesReportParams>({
        dateRange: feesReportFilter.dateRange,
        dealerIds:  [] ,
        searchText: feesReportFilter.searchText,
    })
    useEffect(() => {
        if (filterParam.dealerIds.length === 0 && userDealers.length > 0) {
            getFeeReports({...filterParam, dealerIds: userDealers})
        }
        if (userDealers.length > 0) {
            setDealersData(userDealers)
        }
    }, [userDealers])

    const submitHandler = () => {
        const newFilterParam = {
            ...filterParam,
            searchText: searchRef.current.value,
        } as FeesReportParams
        //dispatch(setFeeReportFilter(newFilterParam))
        if (newFilterParam.dealerIds.length === 0 && userDealers.length > 0) {
            getFeeReports({...newFilterParam, dealerIds: userDealers})
        } else {
            getFeeReports(newFilterParam)
        }
        return false
    }
    const focusOnSearchField = () => {
        searchRef.current.focus()
    }
    useEffect(() => {
        if (filterParam.searchText.length > 0) {
            focusOnSearchField()
        }
    }, [filterParam.searchText])

    const onDealerChange = (e: MultiSelectChangeEvent) => {
        setFilterParams((prevValue: any) => {
            const updatedState = {
                ...prevValue,
                dealerIds: e.value,
            }
            return updatedState
        })
    }

    const dealerItemRender = (li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) => {
        const itemChildren = (
            <span className="reportcheckbox">
                <Checkbox checked={itemProps.selected} onChange={() => {}} />
                &nbsp;{li.props.children}
            </span>
        )
        return React.cloneElement(li, li.props, itemChildren)
    }
    function onDateChange(e: DateRangePickerChangeEvent) {
        e.value.start === null || e.value.end === null ? setDateValidation(false) : setDateValidation(true)
        setDateRange(e.value)
        setFilterParams((prevValue: any) => {
            return {
                ...prevValue,
                dateRange: e.value,
            }
        })
    }
    const selected = filterParam.dealerIds.length
    const SearchInput = (fieldRenderProps: FieldRenderProps) => {
        const {name, onChange, value} = fieldRenderProps
        const [searchText, setSearchText] = useState(value)

        const onChangeTextField = useCallback(
            (event: InputChangeEvent) => {
                setSearchText(event.value)
                onChange(event)
            },
            [onChange],
        )

        return (
            <>
            <Input
                ref={searchRef}
                autoComplete={"off"}
                value={searchText}
                name={name}
                onChange={onChangeTextField}
                id={`search`}
                label={'Search'}
            />
            </>
        )
    }
    return (
        <Form
            initialValues={filterParam}
            render={() => (
                <>
                    <MDBRow className="align-items-end mb-2">
                        <MDBCol md="3" sm="4">
                            <DateRangePicker valid={dateValidation} value={dateRangeValue} onChange={onDateChange} />
                        </MDBCol>
                        <MDBCol md="2" sm="3">
                            <MultiSelect
                            className="reportmultiselect"
                                autoClose={false}
                                filterable={true}
                                onFilterChange={(event: MultiSelectFilterChangeEvent) => {
                                    setDealersData(filterBy(userDealers.slice(), event.filter))
                                }}
                                dataItemKey="dealerId"
                                textField="dealerName"
                                label={"Dealers"}
                                data={dealerData}
                                onChange={onDealerChange}
                                value={filterParam.dealerIds}
                                tags={
                                    selected > 0
                                        ? [{text: `${selected} selected`, data: [...filterParam.dealerIds]}]
                                        : []
                                }
                                itemRender={dealerItemRender}
                            />
                        </MDBCol>
                        <MDBCol md="2" sm="3">
                            <Field name="Search" component={SearchInput} />
                        </MDBCol>
                        <MDBCol>
                            <Button
                                type="submit"
                                fillMode={"flat"}
                                themeColor="primary"
                                onClick={submitHandler}
                                disabled={!dateValidation}
                            >
                                Go
                            </Button>
                        </MDBCol>
                    </MDBRow>
                </>
            )}
        />
    )
}

export default FeesReportFilter
